import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getMyWantToBuyList} from '@/api/miscellaneous';
import moment from 'moment';
import {useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyPurchase',
  props: {
    active: {
        type: String,
        default: '',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props

const router = useRouter();


const list = ref<any[]>([]);
const getListData = ref({
    page: 1,
    size: 10,
});
const loading = ref(false);
const finished = ref(false);

const getList = () => {
    // if (finished.value) return;
    // loading.value = true;
    getMyWantToBuyList(getListData.value).then((res: any) => {
        loading.value = false;
        list.value = [...list.value, ...res.items];
        getListData.value.page++;
        finished.value = res.count == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
    });
};
getList();

const __returned__ = { router, props, list, getListData, loading, finished, getList, ref, getMyWantToBuyList, moment, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})